import React from 'react';
import { RowDetailsProps } from './Table.config';
import { Icon } from '../UI';
import { lowerCase, upperFirst } from 'lodash';

const RowDetails: React.FC<RowDetailsProps> = ({
  title,
  image,
  goBack,
  columns,
  children = null,
}) => {
  return (
    <div className={'w-full h-full flex flex-col'}>
      {/* HEADER */}
      <div className="flex items-center border-b border-grey-10 py-2 px-4 gap-3 dark:border-grey-70">
        <Icon svgName="arrowBack" className="cursor-pointer" onClick={goBack} />
        <img
          src={image}
          alt="collection avatar"
          className="w-12 h-12 object-cover rounded-full"
        />
        <p className="font-semibold text-base -mx-1">{title}</p>
      </div>
      {/* ROWS */}
      <div className={'px-5 py-3 overflow-y-scroll h-full flex flex-col gap-7'}>
        {columns.slice(1).map((column, i) => {
          return (
            <div className={'flex flex-col'} key={column + i}>
              <p className={'text-xs font-medium mb-1'}>
                {upperFirst(lowerCase(column))}
              </p>
              <div>{children && children[i]}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RowDetails;
